module.exports = __webpack_public_path__ + "img/out-hub-logo-partially.d3c233de.svg";